export default {
  methods: {
    format (num) { //千分位转换
      var reg=/\d{1,3}(?=(\d{3})+$)/g;   
      return (num + '').replace(reg, '$&,');  
    },
    render_left(data) {
      console.log(data);
      
      data = data.categorySaleList || []
      data.sort((a,b)=>{
        return a.mouth - b.mouth
      })
      data.forEach(v=>{  //销量千分位转换
        if(v.tips) {
          // v.solesVolumeCount = this.format(v.solesVolumeCount)
          v.tips.forEach(k=>{
            k.saleNum = this.format(k.saleNum)
          })
        }
      })
      let option = {
        // title: {
        //   text: '销售产品概览',
        //   top: 10
        // },
          // subtitle: {
          //     text: `截止到${new Date().getMonth + 1}月，上新数${data.newProductTotal}}共计销量${data.saleNumTotal}`,
          //     top: 0,
          //     right: 0,
          //     textStyle: {
          //       fontSize: 12,
          //       color: '#777',
          //       fontWeight: 'normal'
          //     }
          // },
          dataZoom: {
            type: 'inside',
            start: 0,
            end: data.length<13 ? 100 : (12/data.length)*100
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999',
                      shadowColor: 'rgba(255,255,255,0.1)',
                      shadowBlur: 10
                  }
              },
              confine: true,
              enterable: true,
              hideDelay: 300,
              formatter: params => {
                const arr = data[params[0].dataIndex].tips;
                let str = "";
                str = `${data[params[0].dataIndex].mouth}<br/>`
                if(arr) {
                  arr.forEach(item=>{
                    if(parseInt(item.saleNum)>0) {
                      str += `${item.categoryName}销量${item.saleNum||0}<br/>`
                    }
                  })
                  if(arr.length>13) {
                    return `<div style="height: 300px; overflow: scroll;"><div class="infinity-scroll">${str}</div></div>`
                  }else {
                    return str
                  }
                  
                }else {
                  return ''
                }
                
                // return str
              },
              // position: [10, 10],
              // alwaysShowContent: true,
              // showDelay:20,
              className: 'tooltips-scroll',
              // triggerOn: 'click'
          },
          legend: {
              data: ['销量', '产品数'],
              top: 50,
              textStyle: {
                color: '#fff',
                fontFamily: 'PingFangSC'
              }
          },
          grid: {
            left: 65,
            bottom: 40,
            right: 65,
            top: 120
          },
          xAxis: [
              {
                  type: 'category',
                  data: data.map(v=>v.mouth) || [],
                  axisPointer: {
                    type: 'shadow',
                    label: {
                      show: false
                    }
                  },
                  axisTick: { show: false },
                  axisLabel: {
                    color: 'rgba(255,255,255,0.9)',
                    interval: 0,
                    rotate: data.length>12 ? 45 : 0
                  },
                  axisLine: {
                    lineStyle: {
                      color: 'rgb(135,139,160)'
                    }
                  }
              }
          ],
          yAxis: [
            {    
              name: '销量',
              type: 'value',
              minInterval: 1,
              axisPointer: {
                type: 'line',
                label: {
                  color: '#000',
                  backgroundColor: '#fff',
                }
              },
              axisTick: { show: false },
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#e2e2e2',
                  opacity: 0.5,
                  width: 0,
                  fontFamily: 'PingFangSC',
                }
              },
              splitLine: { show: false }
          },
          {
              name: '产品数',
              type: 'value',
              axisPointer: {
                type: 'line',
                label: {
                  color: '#000',
                  backgroundColor: '#fff',
                }
              },
              minInterval: 1,
              axisTick: { show: false },
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#e2e2e2',
                  opacity: 0.5,
                  width: 0,
                  fontFamily: 'PingFangSC',
                }
              },
              splitLine: { show: false }
          }
          ],
          series: [
              {   
                  name: '销量',
                  type: 'line',
                  yAxisIndex: 0,
                  data: data.map(v=>v.saleNumTotal) || [],
                  itemStyle: {
                    color: 'rgb(250,137,0)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  // showBackground: true,
                  label: {
                    show: true,
                    position: 'top',
                    color: '#e2e2e2',
                    fontFamily: 'PingFangSC'
                  },
                  select: {
                    label: {
                      show: true
                    },
                    itemStyle: {
                      color: '#ffffff',
                      borderColor: '#00A6ED',
                      borderWidth: 0
                    }
                  },
                  selectedMode: true
              },
              {
                  name: '产品数',
                  type: 'bar',
                  yAxisIndex: 1,
                  data: data.map(v=>v.newProCountTotal) || [],
                  itemStyle: {
                    color: 'rgb(11,183,142)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  // showBackground: true,
                  label: {
                    show: true,
                    position: 'top',
                    color: '#e2e2e2',
                    fontFamily: 'PingFangSC'
                  },
                  select: {
                    label: {
                      show: true
                    },
                    itemStyle: {
                      color: '#00A6ED',
                      borderColor: '#00A6ED'
                    }
                  },
                  selectedMode: true
              }
          ],
          animationDelay: function(idx) {
            return 50*idx
          }
      };
      let $instance = this.$echarts.init(this.$refs['overview']);
      $instance.setOption(option);
      $instance.on('click',params => {
        this.dialogFormVisibleLeft = true
        this.leftDialog()
    });
    }
  }
}